// src/boot/logger.js
import { boot } from 'quasar/wrappers';

const levels = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
  none: 4
};

class Logger {
  constructor() {
    this.logLevel = PP_CONST.APP_THEME[PP_CONST.APP_ACTIVE].LOGLEVEL
    this.enabled = PP_CONST.APP_THEME[PP_CONST.APP_ACTIVE].LOGLEVEL !== 4 // process.env.NODE_ENV !== 'production';
    this.plugins = []
  }

  addPlugin(plugin) {
    this.plugins.push(plugin);
  }

  setLogLevel(level) {
    this.logLevel = level;
  }

  enableLogging() {
    this.enabled = true;
  }

  disableLogging() {
    this.enabled = false;
  }

  shouldLog(level) {
    return this.enabled && levels[level] >= this.logLevel;
  }

  debug(...args) {
    if (this.shouldLog('debug')) {
      console.debug('[DEBUG]', ...args);
      this.notifyPlugins('debug', args);
    }
  }

  info(...args) {
    if (this.shouldLog('info')) {
      console.info('[INFO]', ...args);
      this.notifyPlugins('info', args);
    }
  }

  warn(...args) {
    if (this.shouldLog('warn')) {
      console.warn('[WARN]', ...args);
      this.notifyPlugins('warn', args);
    }
  }

  error(...args) {
    if (this.shouldLog('error')) {
      console.error('[ERROR]', ...args);
      this.notifyPlugins('error', args);
    }
  }

  notifyPlugins(level, args) {
    this.plugins.forEach(plugin => {
      if (typeof plugin.log === 'function') {
        plugin.log(level, args);
      }
    });
  }
}

const logger = new Logger();

export default boot(({ app }) => {
  // Globalen Logger bereitstellen
  app.config.globalProperties.$log = logger;

  // Globalen Logger bereitstellen für alle JS-Dateien
  window.logger = logger;

});

export { logger };
